"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.nonNullableObject = exports.removeNullValues = exports.mapObject = exports.getCommonKeys = exports.values = exports.keys = void 0;
const typeHelpers_1 = require("./typeHelpers");
/**
 * Get a typed array of an object's keys
 */
const keys = (x) => Object.keys(x);
exports.keys = keys;
const values = (x) => Object.values(x);
exports.values = values;
const getCommonKeys = (a, b) => {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return aKeys.filter((v) => bKeys.includes(v));
};
exports.getCommonKeys = getCommonKeys;
const mapObject = (x, cb, filter) => {
    return (0, exports.keys)(x).reduce((results, key, i) => {
        const result = cb(x[key], key, i);
        if (!filter || filter(result))
            return Object.assign(Object.assign({}, results), { [key]: result });
        return results;
    }, {});
};
exports.mapObject = mapObject;
function removeNullValues(x) {
    if (!x)
        return undefined;
    return (0, exports.keys)(x).reduce((results, key) => {
        const value = x[key];
        if (value !== null)
            results[key] = value;
        return results;
    }, {});
}
exports.removeNullValues = removeNullValues;
const nonNullableObject = (x) => (0, typeHelpers_1.deleteUndefined)(removeNullValues(x));
exports.nonNullableObject = nonNullableObject;
// export const mergeDeep = mergeDeepApollo;
